import React from 'react';

const Loader = () => {
  return (
    <div className="py-10 mt-14 text-[#D5D5D5] bg-[#121212]">
      <div className="text-3xl text-center font-semibold w-[90%] mx-auto">
        <div className="w-1/3 h-8 bg-white/10 animate-pulse mx-auto rounded" />
      </div>

      <div className="mt-10 relative">
        <div className="w-full flex flex-wrap justify-center gap-5 bg-[#1E1E1E] p-4">
          {Array(4)
            .fill(0)
            .map((_, i) => (
              <div
                key={i}
                className="w-[45%] md:w-[25%] lg:w-[18%] h-12 rounded-full bg-white/10 animate-pulse"
              />
            ))}
        </div>

        <div className="w-[90%] mx-auto lg:h-[480px] 2xl:h-[560px] mt-16">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div className="h-80 flex items-start justify-center">
              <div className="w-64 h-64 rounded-3xl bg-white/10 animate-pulse" />
            </div>

            <div className="text-left space-y-3">
              <div className="h-4 bg-white/10 rounded w-3/4 animate-pulse" />
              <div className="h-4 bg-white/10 rounded w-full animate-pulse" />
              <div className="h-4 bg-white/10 rounded w-5/6 animate-pulse" />
              <div className="h-4 bg-white/10 rounded w-2/3 animate-pulse" />
              <div className="h-4 bg-white/10 rounded w-1/2 animate-pulse" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Loader;
